import {Nullable, DealsManagementListing} from 'common/types';
import {
  FETCH_DEALS_MANAGEMENT_LISTING_FAILURE,
  FETCH_DEALS_MANAGEMENT_LISTING_REQUEST,
  FETCH_DEALS_MANAGEMENT_LISTING_SUCCESS,
  DealsAction,
} from '../types';

interface State {
  data: Nullable<DealsManagementListing>;
  isFetching: boolean;
  error: Nullable<Error>;
}

const initialState: State = {
  data: null,
  isFetching: false,
  error: null,
};

export const managementReducer = (
  state: State = initialState,
  action: DealsAction
) => {
  switch (action.type) {
    case FETCH_DEALS_MANAGEMENT_LISTING_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };

    case FETCH_DEALS_MANAGEMENT_LISTING_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
      };
    case FETCH_DEALS_MANAGEMENT_LISTING_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };

    default:
      return state;
  }
};
